<template>
  <div class="modalWrapper animate" v-if="visible">
    <div class="modalBlock animate">
      <div class="headerWrapper">
        <div class="actionHeadline">
          {{
            getTranslation(
              $store,
              "Product",
              "display_name",
              product.id,
              product.name
            )
          }}
        </div>
        <div class="actionSubline">{{ toPrintable(product.price) }}</div>
      </div>

      <div class="infoWrapper">
        <div class="infoBlock">
          <div class="infoImage">
            <img :src="product.image" />
          </div>
          <div class="infoText">
            <div class="description">
              {{
                getTranslation(
                  $store,
                  "Product",
                  "description",
                  product.id,
                  product.name
                )
              }}
            </div>
            <div class="attributes">
              <div
                class="attribute"
                v-for="(apa, apa_index) in assignedProductAttributes"
                :key="apa.id + '-' + apa_index"
              >
                <img :src="apa.image" /><span>
                  {{
                    getTranslation(
                      $store,
                      "ProductAttribute",
                      "display_name",
                      apa.id,
                      apa.name
                    )
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actionWrapper">
        <div class="confirmActions">
          <deny-button
            @onDeny="hide()"
            :text="$t('dialog.attribute.btn.deny')"
          />
          <confirm-button
            @onConfirm="confirm(product)"
            :text="$t('dialog.attribute.btn.approve')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toCalculatable, toPrintable } from "@/utils/pricing";
import { getTranslation } from "@/utils/helpers";
import { ProductAttributesModalPlugin } from "@/plugins/uimodal.plugin";
import DenyButton from "@/components/modals/common/denyButton.vue";
import ConfirmButton from "@/components/modals/common/confirmButton.vue";

export default {
  components: { ConfirmButton, DenyButton },
  data() {
    return {
      visible: false,
      product: {},
      assignedProductAttributes: [],
      onConfirm: {}
    };
  },
  computed: {
    availableSizesSorted() {
      return this.product.available_sizes
        .slice()
        .sort((a, b) => a.order_by - b.order_by);
    }
  },
  methods: {
    toPrintable,
    getTranslation,
    displayPrice(size) {
      let price = toCalculatable(this.itemSizePrice(size));
      let offset = toCalculatable(size.offset_price);
      if (price + offset === 0.0) return "";
      if (this.menuOffset) {
        if (offset === 0.0) {
          return "";
        }
        return toPrintable(offset, true);
      }
      return toPrintable(price + offset);
    },
    hide() {
      this.visible = false;
    },
    confirm(product) {
      if (typeof this.onConfirm === "function") {
        this.onConfirm(product);
        this.hide();
      } else {
        this.hide();
      }
    },
    show(params) {
      this.visible = true;
      this.product = params.product;
      this.assignedProductAttributes = params.assignedProductAttributes;
      this.onConfirm = params.onConfirm;
    }
  },
  beforeMount() {
    // listen to emitted event "show", see uimodal.plugin.js
    ProductAttributesModalPlugin.EventBus.$on("show", params => {
      this.show(params);
    });
    ProductAttributesModalPlugin.EventBus.$on("hide", () => {
      this.hide();
    });
  }
};
</script>

<style lang="scss" scoped>
@keyframes modalBlockIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes modalWrapperOut {
  0% {
    background-color: rgba(0, 0, 0, 0);
  }
  100% {
    background-color: rgba(0, 0, 0, 0.5);
  }
}
.infoWrapper {
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
}
.infoBlock {
  background: #fff;
  border-radius: 15px;
  width: 910px;
  display: flex;
  flex-flow: row wrap;
  padding-top: 20px;
}

.infoImage {
  width: 430px;
}

.infoImage img {
  width: 390px;
  margin: 20px;
  object-fit: contain;
}

.infoText {
  width: 480px;
  padding: 20px 40px 20px 20px;
  font-family: var(
    --component_modals_common_productAttributes_infoText_font-family
  );
  font-size: 18px;
  text-align: left;
  .description {
    margin-bottom: 20px;
  }
  .attributes {
    width: 480px;
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    .attribute {
      display: flex;
      align-items: center;
      padding: 0 20px 10px 0;
      img {
        width: 32px;
        height: 32px;
        object-fit: contain;
        padding: 0 10px 0 0;
      }
    }
  }
}

.infoDescription {
  width: 390px;
  margin: 20px;
}

.confirmActions {
  display: flex;
  justify-content: space-between;
  padding: 50px 0 0 0;
  width: 910px;
}

.modalWrapper {
  display: flex;
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 1300;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: flex-start;
  background-color: rgba(0, 0, 0, 0.5);
}

.modalWrapper.animate {
  /*animation: modalWrapperOut 0ms forwards ease;*/
}

.modalBlock {
  align-self: flex-start;
  box-shadow: 0 0 50px #00000029;
  color: black;
  border-radius: var(
    --component_modals_common_productAttributes_modalBlock_border-radius
  );
  background: var(
    --component_modals_common_productAttributes_modalBlock_background
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 335px 0 0 0;
  padding: 50px 20px;
  text-align: center;
  width: 95vw;
  z-index: 1300;
}

.modalBlock.animate {
  animation: modalBlockIn 500ms forwards ease;
}

.actionWrapper {
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
}

.headerWrapper {
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
}

.actionHeadline {
  color: var(--component_modals_common_productAttributes_actionHeadline_color);
  font-family: var(
    --component_modals_common_productAttributes_actionHeadline_font-family
  );
  font-size: var(
    --component_modals_common_productAttributes_actionHeadline_font-size
  );
  text-align: left;
  text-transform: var(
    --component_modals_common_productAttributes_actionHeadline_text-transform
  );
  width: 910px;
}
.actionSubline {
  margin-top: 6px;
  margin-bottom: 30px;
  color: var(--component_modals_common_productAttributes_actionSubline_color);
  font-family: var(
    --component_modals_common_productAttributes_actionSubline_font-family
  );
  font-size: var(
    --component_modals_common_productAttributes_actionSubline_font-size
  );
  text-align: left;
  width: 910px;
}
</style>
